import { toPresentationException } from '../http/error';
import { IPresentationException } from '../interface';
import { renderError } from './render-error';

const shouldRefreshPage = (error: IPresentationException) => {
  const status = parseInt(`${error.status}`);

  return status >= 401 && status <= 403;
};

const displayError = (error: IPresentationException) => {
  if (shouldRefreshPage(error)) {
    window.location.reload();
  } else {
    renderError(error);
  }
};

const handleError = (error: Error | any) => {
  displayError(toPresentationException(error));
};

export { handleError };
